module.exports = __webpack_public_path__ + "open-sans-v17-latin-regular.woff?de0869e324680c99efa1250515b4b41c";